(() => {
  const preservePreview = new URL(window.location.href).searchParams.get('view') === 'creatine';

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const closeButton = event.target.closest('[data-creatine-facts-close]');
    if (closeButton) {
      const panel = closeButton.closest('[data-creatine-facts-panel]');
      panel.open = false;
      panel.querySelector('summary').focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'start', behavior: 'auto' });
      return;
    }
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('variant-radios, variant-selects')) return;
    // Leave price, media, availability and cart state to the native variant picker.
    // Facts panels open only from their own headings, never from purchase selection.
    if (preservePreview) {
      queueMicrotask(() => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', 'creatine');
        window.history.replaceState({}, '', url);
      });
    }
  });

  // Keep the existing floating review tab from covering label text on small screens.
  const factsSection = document.getElementById('creatine-facts');
  if (factsSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      document.body.classList.toggle('se-creatine-reading-facts', entries[0].isIntersecting);
    });
    observer.observe(factsSection);
  }
})();
